<template>
    <div class="card-data md">
        <Tooltip 
            :tip="tip" />
        <div class="card-title">
            <h5 class="title">{{title}}</h5>
            <div style="height: 29px"></div>
        </div>
        <div v-if="!loader">
            <Loader/>
        </div>
        <!-- <div v-else-if="fiveMins==0">
            <EmptyStateChart
            :title="titleEmpty"
            :caption="captionEmpty"
            />
        </div> -->
        
        <div v-else class="card-dwelltime">
            <div class="dwell-container">
                <ICountUp
                    :endVal="fiveMins"
                    :options="options"
                    class="dwelltime-data"
                    /> 
                <p class="percent">%</p>
                <!-- <p class="infra-group">5-20 min</p> -->
                <p class="infra-group">5-60 min</p>
            </div>
            <div class="dwell-container" >
                <ICountUp
                    :endVal="twentyMins"
                    :options="options"
                    class="dwelltime-data"
                    /> 
                <p class="percent">%</p>
                <!-- <p class="infra-group">20-60 min</p> -->
                <p class="infra-group">1-6 hrs</p>
            </div>
            <div class="dwell-container">
                <ICountUp
                    :endVal="sixtyMins"
                    :options="options"
                    class="dwelltime-data"
                    /> 
                <p class="percent">%</p>
                <!-- <p class="infra-group">60+ min</p> -->
                <p class="infra-group">6+ hrs</p>
            </div>
        </div>
        
    </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'

export default {
    name: 'AmountDwellTime',
    components: {
        ICountUp,
        Loader,
        Tooltip,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        tip: {
            type: String,
            required: false
        },
        data: {
            type: Object,
            required: true
        },
        loader: {
            type: Boolean,
            default: false
        },
        captionEmpty:{
            type: String,
            default: "Puedes consultar la vista de los últimos 7 o 30 días.",
        },
        titleEmpty: {
            type: String,
            default: "Este gráfico no esta disponible para esta vista"
        }
    },
    data: function(){
        return {
            options: {
                useEasing: true,
                useGrouping: true,
                duration: 0.6,
                separator: '.',
                decimal: ',',
                prefix: '',
                suffix: ''
            }
        }
    },
    computed: {
        fiveMins: function() {
            if (this.data.fiveMins + this.data.twentyMins + this.data.sixtyMins) {
                return (this.data.fiveMins * 100) / (this.data.fiveMins + this.data.twentyMins + this.data.sixtyMins)
            }
            return 0
        },
        twentyMins: function() {
            if (this.data.fiveMins + this.data.twentyMins + this.data.sixtyMins) {
                return (this.data.twentyMins * 100) / (this.data.fiveMins + this.data.twentyMins + this.data.sixtyMins)
            }
            return 0
        },
        sixtyMins: function() {
            if (this.data.fiveMins + this.data.twentyMins + this.data.sixtyMins) {
                return (this.data.sixtyMins * 100) / (this.data.fiveMins + this.data.twentyMins + this.data.sixtyMins)
            }
            return 0
        }
    },
}
</script>

<style lang="sass">
.card-data .actual 
    font-family: $title-font
    font-size: 40px
    font-weight: 600
    text-align: right
    color: $dark
    @media (max-width: $phone)
        font-size: 28px


.card-data .indicator 
    @media (max-width: $phone)
        margin-left: 8px


.card-data .infra-data 
    display: inline-block
    margin-bottom: 2px


.card-data .infra-group 
    font-family: $body-font
    font-size: 12px
    font-weight: 300
    text-align: center
    color: $dark
    flex-grow: 1
    order: 3
    align-self: flex-end
    width: 100%

.dwell-container
    display: flex
    flex-wrap: wrap
    justify-items: center
    align-items: baseline
    align-content: stretch
    width: 90px
    font-size: 40px
    font-weight: 600
    @media (max-width: $phone)
        margin-top: $xs
        font-size: 30px
        width: 70px
    .dwelltime-data
        order: 1
        color: $dark
        flex-grow: 1  
        @include tablet-landscape
            font-size: 24px
            text-align: right
        @include tablet-portrait
            font-size: 32px

    .percent
        order: 2
        flex-grow: 1
        @include tablet-landscape
            font-size: 24px
        @include tablet-portrait
            font-size: 32px

</style>